import { getUser } from './localStorage'

export function addItemToOptimisticBasket(basket, user, storeId, price, item) {
  return {
    id: basket ? basket.id : 'optimistic_basket',
    user_id: user ? user.id : getUser().anon_user_id,
    store_id: storeId,
    platform_fee: (basket || {}).platform_fee,
    state: (basket || {}).state,
    order_id: (basket || {}).order_id,
    campaign: (basket || {}).campaign,
    no_fee_campaign: (basket || {}).no_fee_campaign,
    discount_amount: basket ? basket.discount_amount : 0,
    item_total: basket ? basket.item_total + price : price,
    total: basket ? basket.total + price : price,
    items: basket ? [...basket.items, item] : [item],
    __typename: 'Basket',
  }
}

export function removeItemFromOptimisticBasket(basket, item_id) {
  const removing = basket.items.find(({ id }) => id === item_id)
  return {
    id: basket.id,
    user_id: basket.user_id,
    store_id: basket.store_id,
    platform_fee: basket.platform_fee,
    state: basket.state,
    order_id: basket.order_id,
    campaign: basket.campaign,
    no_fee_campaign: basket.no_fee_campaign,
    discount_amount: basket.discount_amount,
    item_total: basket.item_total - (removing || {}).price,
    total: basket.total - (removing || {}).price,
    items: basket.items.reduce(
      (arr, item) => item.id !== item_id ? [...arr, { ...item, __typename: 'BasketItem' }] : arr,
      []
    ),
    __typename: 'Basket',
  }
}

export function updateItemInOptimisticBasket(basket, product, optimisticItem) {
  const expectedPriceChange = optimisticItem.price * (optimisticItem.quantity - product.quantity)
  return {
    id: basket.id,
    user_id: basket.user_id,
    store_id: basket.store_id,
    platform_fee: basket.platform_fee,
    state: basket.state,
    order_id: basket.order_id,
    campaign: basket.campaign,
    no_fee_campaign: basket.no_fee_campaign,
    discount_amount: basket.discount_amount,
    item_total: basket.item_total + expectedPriceChange,
    total: basket.total + expectedPriceChange,
    items: basket.items.map(item => item.id === product.id
      ? { ...optimisticItem, __typename: 'BasketItem' }
      : { ...item, __typename: 'BasketItem' }),
    __typename: 'Basket',
  }
}
